<section id="secao-projeto-educere">
  <div class="container">
    <div class="titulo-oque-e-o-projeto">
      <h3>O que é o Projeto Educere</h3>
    </div>

    <div class="parag-oque-e-o-projeto">
      <p>
        É um projeto para adolescentes entre 14 e 16 anos voltado a iniciação
        tecnológica à área de pesquisa e desenvolvimento(P&D), com ênfase em
        eletrônica e mecânica. O objetivo do Projeto Educere é despertar o
        interesse pela área de tecnologia e incentivá-los a desenvolver novos
        produtos para o mercado, seja como empreendedores ou desenvolvedores de
        produto. O projeto tem duração de aproximadamente 2 anos e é totalmente
        gratuito. <br />Os alunos têm aulas de mecânica e programação básica,
        gestão de projetos e empreendedorismo, complementadas com práticas de
        laboratório, utilização de softwares avançados para o desenvolvimento de
        projetos e prototipagem , entre outros, em um ambiente colaborativo e
        empreendedor. As aulas são ministradas, em sua maioria, por
        profissionais voluntários do ecossistema Educere (colaboradores das
        empresas mantenedoras e parceiras). Os alunos têm, ainda, a oportunidade
        de visitar as empresas do ecossistema Educere e de conhecer os
        empresários e profissionais dessas empresas.
      </p>
    </div>
  </div>
</section>
